import {
    ApplicationBarProps,
    ApplicationBar,
} from "@impero-com/common/components/applicationBar/applicationBar";

import { useNewMenu } from "../../org/navigation/useNewMenu";

import { ApplicationHeader, ApplicationHeaderProps } from "./applicationHeader";

export type OrgApplicationBarProps = ApplicationHeaderProps &
    Omit<ApplicationBarProps, "header" | "variant">;

export function OrgApplicationBar({
    title,
    routerLinks,
    ...rest
}: OrgApplicationBarProps) {
    const newMenu = useNewMenu();

    return (
        <ApplicationBar
            {...rest}
            variant={newMenu ? "flat" : "default"}
            header={
                <ApplicationHeader title={title} routerLinks={routerLinks} />
            }
        />
    );
}
